import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import InlineSvg from 'vue-inline-svg';

Vue.use(VueCompositionAPI);

document.addEventListener('DOMContentLoaded', () => {
  Vue.component('InlineSvg', InlineSvg);
});
